import React, {Fragment, useEffect} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import AsyncSelect from "react-select/async";


const ProductSizeForm = (props) => {
    const {
        errors,
        control,
        register,
        setValue,
        trigger,
        getValues,
        watch,
        masterSizePromiseOption,
        searchSellersByName,
        sellers,
        setOptions,
        promiseOptions
    } = props;

    const isMaster = watch ? watch('is_master') : false;

    useEffect(() => {
        if (isMaster) {
            setValue('master_size_id', null);
        }
    }, [isMaster, setValue]);


    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Product Size Name(UK Size)<span style={{color :"red"}}>*</span></Label>
                        <input name="name" type="text" {...register('name')} className={`form-control ${errors.name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">US Size<span style={{color :"red"}}>*</span></Label>
                        <input name="name" type="text" {...register('us_size')}
                               className={`form-control ${errors.us_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.us_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">EU Size<span style={{color :"red"}}>*</span></Label>
                        <input name="name" type="text" {...register('eu_size')}
                               className={`form-control ${errors.eu_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.eu_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">IN Size</Label>
                        <input name="name" type="text" {...register('in_size')}
                               className={`form-control ${errors.in_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.in_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup className="mb-2">
                        <div className="checkbox checkbox-primary">
                            <input id="is_master" type="checkbox" {...register('is_master')}/>
                            <Label for="is_master" className="col-form-label">Mark as master size</Label>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            {!isMaster && <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Map with master size</Label>
                        <AsyncSelect
                            name="master_size_id"
                            isClearable
                            defaultOptions
                            placeholder="Select Master Size"
                            defaultValue={getValues('master_size_id')}
                            loadOptions={masterSizePromiseOption}
                            error={errors.master_size_id}
                            onChange={(e) => {
                                setValue('master_size_id', e)
                                trigger('master_size_id');
                            }}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            className={` ${errors.master_size_id ? 'is-invalid' : ''}`}
                        />
                        <div className="invalid-feedback">{errors.master_size_id?.message}</div>
                    </FormGroup>
                </Col>
            </Row>}
        </Fragment>
    );
};

export default ProductSizeForm;
